// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-input {
  display: flex;
  flex-direction: row;
  gap: 40px;
}

.media-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.client-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media-row {
  margin-top: 5px;
}

.plus-button {
  display: flex;
  justify-content: center;
  //align-self: center;
  margin: 10px;
  width: 40px;
  background-color: gray;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.calendar-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px;
}

.special-requests {
  display: flex;
  flex-direction: column;
}

.request-input {
  margin-bottom: 15px;
  margin-top: 15px;
  width: 250px;
}

.additional-options {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25%;
}

.output {
  width: 50%;
}

.generate-button {
  background: linear-gradient(to right, #1E9E1E, #006400);
  border: none;
  color: #FFFFFF;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.generate-button::before {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  background: linear-gradient(to right, #1E9E1E, #006400);
  z-index: -1;
}

.generate-button:hover {
  background: linear-gradient(to right, #006400, #1E9E1E);
}

.generate-button:hover::before {
  background: linear-gradient(to right, #006400, #1E9E1E);
}

.generate-button.disabled {
  background: #CCCCCC;
  cursor: not-allowed;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uDAAuD;EACvD,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".search-input {\n  display: flex;\n  flex-direction: row;\n  gap: 40px;\n}\n\n.media-selector {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.client-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.media-row {\n  margin-top: 5px;\n}\n\n.plus-button {\n  display: flex;\n  justify-content: center;\n  //align-self: center;\n  margin: 10px;\n  width: 40px;\n  background-color: gray;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.calendar-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 30px;\n}\n\n.special-requests {\n  display: flex;\n  flex-direction: column;\n}\n\n.request-input {\n  margin-bottom: 15px;\n  margin-top: 15px;\n  width: 250px;\n}\n\n.additional-options {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 25%;\n}\n\n.output {\n  width: 50%;\n}\n\n.generate-button {\n  background: linear-gradient(to right, #1E9E1E, #006400);\n  border: none;\n  color: #FFFFFF;\n  padding: 10px 20px;\n  font-size: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.generate-button::before {\n  content: '';\n  position: absolute;\n  top: -5px;\n  left: -5px;\n  right: -5px;\n  bottom: -5px;\n  background: linear-gradient(to right, #1E9E1E, #006400);\n  z-index: -1;\n}\n\n.generate-button:hover {\n  background: linear-gradient(to right, #006400, #1E9E1E);\n}\n\n.generate-button:hover::before {\n  background: linear-gradient(to right, #006400, #1E9E1E);\n}\n\n.generate-button.disabled {\n  background: #CCCCCC;\n  cursor: not-allowed;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
